"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.abbrOb = exports.createLogger = exports.configure = void 0;
const tslib_1 = require("tslib");
const pino_1 = tslib_1.__importDefault(require("pino"));
const util_1 = require("../lib/util");
let defaultLevel;
if (typeof self !== 'undefined' &&
    typeof self.location !== 'undefined' &&
    typeof URLSearchParams !== 'undefined' &&
    self.location.search) {
    const params = new URLSearchParams(self.location.search);
    if (params.has('loglevel')) {
        defaultLevel = util_1.levelMap[params.get('loglevel')];
    }
}
if (!defaultLevel &&
    process.env.NODE_ENV !== 'production' &&
    typeof self !== 'undefined' &&
    typeof self.localStorage !== 'undefined') {
    const storedLoglevel = self.localStorage.getItem('loglevel:owl');
    if (storedLoglevel) {
        defaultLevel = util_1.levelMap[storedLoglevel];
    }
}
if (!defaultLevel) {
    if (process.env.OWL_LOG_LEVEL) {
        defaultLevel = util_1.levelMap[process.env.OWL_LOG_LEVEL];
    }
    else {
        defaultLevel = process.env.NODE_ENV === 'production' ? 'warn' : 'info';
    }
}
function mkLogFn(level, method) {
    return function (ob) {
        const { level: dummyLevel, time: dummyTime, name, msg, ...rest } = ob;
        if (name) {
            // eslint-disable-next-line no-console
            console[method](`%c[${name}]%c ${msg ?? '%o'}`, 'color:#a0a0a0', 'color:inherit', rest);
        }
        else {
            // eslint-disable-next-line no-console
            console[method](msg ?? '%o', rest);
        }
    };
}
const write = {
    fatal: mkLogFn('fatal', 'error'),
    error: mkLogFn('error', 'error'),
    warn: mkLogFn('warn', 'warn'),
    info: mkLogFn('info', 'info'),
    debug: mkLogFn('debug', 'log'),
    trace: mkLogFn('trace', 'log'),
};
const pinoOptions = {
    level: defaultLevel,
    // redact, // TODO: Redaction is nice but it *mutates logged objects*!
    formatters: { level: (lvl /*, number: number*/) => ({ level: lvl }) },
    browser: {
        write,
    },
};
let baseLogger = (0, pino_1.default)({
    ...pinoOptions,
    level: defaultLevel,
});
let createdLoggers = false;
let configured = false;
function configure(opts) {
    if (configured) {
        throw new Error('Already configured logger');
    }
    else if (createdLoggers) {
        throw new Error('Trying to configure logger after use; make sure to configure before creating named loggers');
    }
    configured = true;
    defaultLevel = (opts.level ?? defaultLevel);
    return (baseLogger = (0, pino_1.default)({
        ...pinoOptions,
        level: defaultLevel,
    }));
}
exports.configure = configure;
function createLogger(label, suffix) {
    createdLoggers = true;
    // If the Webpack build does not expose meaningful filenames
    // (=path looks like [pseudo]-FS root), don't bother injecting them.
    const hasMeaningfulName = label !== '/index.js' || suffix;
    const child = hasMeaningfulName
        ? baseLogger.child({ name: (0, util_1.getLoggerName)(label, suffix) })
        : baseLogger.child({});
    const isLevelEnabled = child.isLevelEnabled;
    if (hasMeaningfulName) {
        // Firefox throws an error if you try to set `name`
        Object.defineProperty(child, 'name', {
            writable: true,
            enumerable: true,
            ...Object.getOwnPropertyDescriptor(child, 'name'),
            value: label,
            configurable: true,
        });
    }
    return Object.assign(child, {
        label,
        isLevelEnabled: (level) => isLevelEnabled.call(child, util_1.levelMap[level]),
    });
}
exports.createLogger = createLogger;
var util_2 = require("../lib/util");
Object.defineProperty(exports, "abbrOb", { enumerable: true, get: function () { return util_2.abbrOb; } });
//# sourceMappingURL=index.js.map